import { AuthService } from './../services/auth.service';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthAccessDeniedGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (!this.authService.isLoggedIn()) {
			return true;
		} else {
			this.router.navigate(['vendor']);
			return false;
		}
	}
}
